
import { defineComponent, nextTick } from 'vue';
import PrzPost from '@/components/Social/Post/Desktop.vue';
import { SocialProfile } from "@/models/Social/social-profile";
import { SocialMediaShape } from '@/models/Social/social-mention';
import { BlockProduct } from '@/models/Blocks/Itens/block-product';
import PrzNewComment from '@/components/Social/Dialogs/Parts/NewComment/Component.vue';
import PrzTabProduct from '@/components/Muffin/List/Products/ShopItem.vue';
import PrzTabQuestions from '@/components/Social/Dialogs/Component.vue';
import Mub from "@/components/Mub.vue";

import Common from './Common.vue';

export default defineComponent({
    components: {
        PrzPost,
        PrzTabProduct,
        PrzTabQuestions,
        PrzNewComment,
        Mub,
    },
    extends: Common,
    mounted(){
        this.calcExtensive();
        this.calcHeight();
        nextTick(() => {
            this.calcHeight();
        });
        this.showFollow();
        window.addEventListener("resize",this.calcHeight);
        this.openDefaultTab();
    },
    watch:{
        mention(){
            this.calcHeight();
            this.calcExtensive();
            this.showFollow();
        },
        collapsed(){
            this.calcHeight();
        }
    },
    beforeDestroy(){
        window.removeEventListener("resize",this.calcHeight);
    },
    data(){
        let detailsStyle: any = undefined;
        let questionsStyle: any = undefined;
        return {
            translate: false,
            allText: false,
            extensive: false,
            collapsed: true,
            detailsStyle,
            questionsStyle,
            showFollowClick: true,
            hasReplyBox: false
        }
    },
    computed:{
        isVertical(): boolean{
            let shape = this.mention?.post.media?.shape??SocialMediaShape.SQUARE;
            return shape == SocialMediaShape.VERTICAL;
        },
        profile(): SocialProfile|undefined{
            return this.socialMention?.profile ?? undefined;
        },
        isFollowing(): boolean{
            return this.mention && this.mention.profile && this.mention.profile.following ? true: false;
        },
        buttonText(): string|undefined{
            return this.isFollowing ? this.kStrings.following : this.kStrings.follow
        },
        text(): string|undefined{
            return !this.translate ? this.mention.post.text : this.mention.post.transaction;
        }
    },
    methods:{
        openDefaultTab(){
            //Please Check this Sergio
            if(this.mention.products.length > 0){
                this.action('products');
            }else{
                this.action('questions');
            }

            // let storage = window.sessionStorage ?? null;
            // let openQuestions: boolean = true;
            // let wind   = (window as any);
            // let perf   = wind.performance || wind.msPerformance || wind.webkitPerformance || wind.mozPerformance;
            // let isBack = perf && perf.navigation.type == perf.navigation.TYPE_BACK_FORWARD;
            // if(storage){
            //     let groupId = storage.getItem('mentionproducts');
            //     if(groupId && isBack){
            //         this.action('products');
            //         openQuestions = false;
            //         storage.removeItem('mentionproducts');
            //     }
            // }
            // if(openQuestions){
            //     this.action('questions');
            // }
        },
        showReply(value: boolean){
            this.hasReplyBox = value;
        },
        calcExtensive(){
            let elem = this?.$el?.querySelector('.prz-social-metion-post') ?? null;
            if(elem && (elem instanceof HTMLElement)){
                this.extensive = elem.offsetHeight >= 70;
            }
        },
        openProduct(item: BlockProduct){
            let storage = window.sessionStorage ?? null;
            if(storage){
                storage.setItem('mentionproducts', (item?.groupId ?? '1'));
            }
        },
        showFollow(){
            this.showFollowClick = true;
            /*if(!this.isGuest){
                this.showFollowClick = true;
            }else{
                let baseElem = this?.$el?.closest('.prz-mention-modal') ?? null;
                this.showFollowClick = baseElem ? false : true;
            }*/
        },
        async calcHeight(){
            let elem = this?.$el?.querySelector('.prz-social-metion-media') ?? null;
            this.detailsStyle = undefined;
            if(elem && (elem instanceof HTMLElement)){

                //force to short, because is in flexbox
                this.detailsStyle = {height: '100px'};
                await nextTick();
                this.detailsStyle = {height: `${elem.offsetHeight + 1}px`};


                let tab = this?.$el?.querySelector('.prz-social-mention-selected-tab') ?? null;
                if(tab && (tab instanceof HTMLElement)){
                    let coment = this?.$el?.querySelector('.prz-social-metion-dkt-coment') ?? null;
                    let margin = coment && coment instanceof HTMLElement ? coment.offsetHeight : 0;
                    if(margin <= 0){
                        margin = 20;
                    }
                    this.questionsStyle = this.collapsed ? {'min-height': `${elem.offsetHeight - tab.offsetTop - margin}px`} : {'margin-bottom': `${margin}px`};
                }
            }
        },
        close(){
            this.$emit('close');
        },
        async followClick(){
            await this.mention?.profile?.like?.click();
        },
        action(type: string){
            this.openTabs();
            this.collapsed = true;
            this.tabSelected = type;
            nextTick(() => {
                this.calcHeight();
            });
        }
    }
});
